export default __webpack_public_path__ + "static/media/pedro-santos-dVtLtQ9RSGc-unsplash.b135c695.svg";